module.exports = __webpack_public_path__ + "img/trinapp_construction.92be4295.png";